import { useMemo } from 'react';
import type { AssessmentFormUiConfig } from '../utils/assessmentFormConfig';
import { DEFAULT_ASSESSMENT_FORM_UI_CONFIG } from '../utils/assessmentFormConfig';
import { buildFormConfigFromSubCapability } from '../utils/subCapabilityAssessmentConfig';
import { sameAssessmentUnit } from '../utils/assessmentUnitUtils';

interface SelectedSubRef {
  capabilityId?: number | null;
  subCapabilityId?: number | null;
}

/**
 * Resolves assessment question/maturity copy from the selected unit.
 * Leaf capabilities (no children) carry the questions themselves.
 */
export function useAssessmentFormConfig(
  data: any,
  selectedSubCapability?: SelectedSubRef | null
): { formConfig: AssessmentFormUiConfig } {
  const formConfig = useMemo(() => {
    const capabilities =
      data?.data?.selectedCapabilities ?? data?.selectedCapabilities ?? null;

    if (!capabilities?.length || selectedSubCapability?.capabilityId == null) {
      return DEFAULT_ASSESSMENT_FORM_UI_CONFIG;
    }

    for (const capability of capabilities) {
      const match = capability.selectedSubCapabilities?.find(
        (sub: any) =>
          sameAssessmentUnit(
            capability.capabilityId,
            sub.subCapabilityId,
            selectedSubCapability.capabilityId,
            selectedSubCapability.subCapabilityId
          )
      );
      if (match) {
        return buildFormConfigFromSubCapability(match);
      }
    }

    return DEFAULT_ASSESSMENT_FORM_UI_CONFIG;
  }, [data, selectedSubCapability?.capabilityId, selectedSubCapability?.subCapabilityId]);

  return { formConfig };
}

export function getSubCapabilityFormConfig(subCapability: any): AssessmentFormUiConfig {
  return buildFormConfigFromSubCapability(subCapability);
}
